module.exports = __webpack_public_path__ + "img/syncmanager_logo.56b5b052.png";